import { render } from "./CookiePopUp.vue?vue&type=template&id=15b3d847&scoped=true"
import script from "./CookiePopUp.vue?vue&type=script&lang=js"
export * from "./CookiePopUp.vue?vue&type=script&lang=js"

import "./CookiePopUp.vue?vue&type=style&index=0&id=15b3d847&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-15b3d847"

export default script